import classNames from 'classnames';
import { Checkbox } from 'antd';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash-gradient.svg';
import { ReactComponent as EditIcon } from '@Icons/additional/edit-blue.svg';
import { ReactComponent as LockIcon } from '@Icons/additional/lock.svg';
import { ReactComponent as DownloadIcon } from '@Icons/additional/download-gradient.svg';
import { useDownloadDocumentQuery } from '@Store/api/dmsApiSlice';
import { LogoType } from '@Components/Base';

import styles from './document-item.module.css';

interface DocumentItemProps {
  docName: string;
  docDesc: string;
  type: string;
  procDocTypeOption: string;
  isConfidential: boolean;
  deleteFlag: boolean;
  checkedItem?: boolean;
  isSelected?: boolean;
  filePath?: string;
  documentId?: string;
  handleDeleteItem: () => void;
  handleDownloadItem?: (url: string | undefined, filePath: string) => void;
  handleEditItem: () => void;
  handleUnselectItem?: () => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({
  docName,
  docDesc,
  type,
  procDocTypeOption,
  deleteFlag,
  checkedItem,
  isConfidential,
  isSelected,
  filePath,
  documentId,
  handleUnselectItem,
  handleDeleteItem,
  handleDownloadItem,
  handleEditItem,
}) => {
  const { data: fileUrl } = useDownloadDocumentQuery(documentId || '', {
    skip: !documentId,
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {isSelected && (
          <Checkbox
            className={styles.checkbox}
            checked={checkedItem}
            onChange={handleUnselectItem}
          />
        )}
        <div className={styles.wrapper}>
          <div className={styles.documentIcon}>
            <LogoType fileExt={type} />
          </div>
          <div>
            <div className={classNames(styles.caption, styles.documentName)}>
              {docName} {isConfidential && <LockIcon />}
            </div>
            <div className={styles.documentType}>{procDocTypeOption}</div>
          </div>
        </div>
        <div className={styles.actions}>
          <div
            className={classNames(
              styles.state,
              deleteFlag ? styles.inactive : styles.active
            )}
          >
            {deleteFlag ? 'Inactive' : 'Active'}
          </div>

          {handleDownloadItem && documentId && filePath && (
            <div
              className={styles.icon}
              onClick={() => handleDownloadItem(fileUrl, filePath)}
            >
              <DownloadIcon />
            </div>
          )}

          <div className={styles.icon} onClick={handleDeleteItem}>
            <DeleteIcon />
          </div>
          <div className={styles.divider} />
          <div className={styles.icon} onClick={handleEditItem}>
            <EditIcon />
          </div>
        </div>
      </div>
      <div className={styles.content}>{docDesc}</div>
    </div>
  );
};

export default DocumentItem;
